import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ActionDropdownComponent } from 'src/app/components/action-dropdown/action-dropdown.component';
import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';

import { AdminAccountRoutingModule } from './admin-account-routing.module';
import { AdminAccountComponent } from './admin-account.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AdminAccountRoutingModule, CustomFieldsModule],
  declarations: [AdminAccountComponent],
})
export class AdminAccountModule {}
